const DEFAULT_COLLECTION_REDUX_STATE = {
  collection: 'portfolio',
  collections: [],
  collectionsData: {},
  loadedCollections: [],
  loadingCollection: false,
};

export default DEFAULT_COLLECTION_REDUX_STATE;
